/**
 * Layout.tsx
 * ----------
 * Page layout wrapper.
 * - Includes Header, Footer, and main content area.
 */


import React from 'react';
import { Helmet } from 'react-helmet';
import Header from './Header';
import Footer from './Footer';

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  return (
    <>
      <Helmet>
        <html lang="fi" />
      </Helmet>

      <Header />

      <main className="flex flex-grow justify-center items-center ">
        {children}
        
        </main>

      <Footer />
    </>
  );
};

export default Layout;
